<template>
  <div row wrap justify-center align-center pb-2>
    <vs-row xs12 sm12 md10>
      <div class="sunset-expired-box">
        <p v-if="sunsetContactEmail" v-html="$i18n.t('login.error.sunset_with_org_email', {
            sunsetOrganizationName,
            sunsetEffectiveDate,
            sunsetContactEmail
          })"
        ></p>
        <p v-else v-html="$i18n.t('login.error.sunset_without_org_email', {
            sunsetOrganizationName,
            sunsetEffectiveDate
          })"
        ></p>
      </div>
    </vs-row>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'sunset-login-notice',
  props: {
    organizationName: {
      type: String,
      required: false,
      default: null
    },
    effectiveDate: {
      type: [String, Number, Date],
      required: false,
      default: null
    },
    contactEmail: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    sunsetOrganizationName () {
      return this.organizationName || '';
    },
    sunsetEffectiveDate () {
      if (!this.effectiveDate) return '';
      return moment.utc(this.effectiveDate)
        .locale(localStorage.getItem('currLang'))
        .format('DD MMMM YYYY');
    },
    sunsetContactEmail () {
      return this.contactEmail || '';
    }
  }
};
</script>
<style scoped>
.sunset-expired-box {
  --sunset-warning-base: var(--StarlingWarning, #F5A200);
  background: color-mix(in srgb, var(--sunset-warning-base) 10%, transparent);
  border: 2px solid color-mix(in srgb, var(--sunset-warning-base) 40%, transparent);
  border-radius: 10px;
  padding: 18px 22px;
  font-size: 16px;
  line-height: 1.45;
  color: var(--StarlingDarkblue, #2d2d2d);
  box-sizing: border-box;
}
</style>
